<template>
  <div class="box boxYl">
    <el-row :gutter="10">
      <el-col :span="4" style="width:14%;padding-right: 12.5px;">
        <div class="grid-content bg-purple">
          <div class="treecontent">
            <!-- <tree-tab
              :obj="treeTabObj"
              @load="bindGetTreeTabCode"
              @click="bindGetTreeTabCode"
              v-if="treeTabObj"
            ></tree-tab>
            <nk-left-tree
              ref="tree"
              :data="leftTreeData"
              :defaultCurrent="false"
              :checkbox="false"
              v-if="leftTreeData.length > 0"
              @click="bindTreeClick"
            ></nk-left-tree> -->
            <tab-tree
              :data="viewTreeData"
              @tabTreeDefault="tabTreeDefault"
              @tabTreeClick="tabTreeClick"
            ></tab-tree>
          </div>
        </div>
      </el-col>
      <el-col :span="24" style="width:86%;padding-left: 12.5px;">
        <div class="grid-content bg-purple">
          <div class="box bgbox">
            <!-- <div class="time_box">
              <data-type
                ref="search"
                :alarnclass="alarnclass"
                :timeInterval="timeInterval"
                @getData="getSearchElem"
                :timeType="timeType"
              ></data-type>
            </div> -->
            <div class="time_box dn-content-bg">
              <time-search
                ref="timeSearch"
                :control="{ data: timeData }"
                @timeControlClick="getSearchElem"
              >
              </time-search>
            </div>
            <div class="contant_box setHeight">
              <div class="barTop">
                <el-col :span="16" style="padding-left:0;padding-right:10px">
                  <div style="height:100%">
                    <bar :barDate1="barDate1"></bar>
                  </div>
                </el-col>
                <el-col :span="8" style="padding-left:10px;padding-right:0">
                  <guan :pie="pie"></guan>
                </el-col>
              </div>
              <!-- style="height:49%;margin-top:20px" -->
              <div class="barbottom">
                <el-col :span="16" class="barTopleft">
                  <nk-table
                    :showPage="false"
                    :columns="columns"
                    :maxHeight="400"
                    :data="tableData1"
                    style="height: 100%;
                    overflow: auto;"
                  ></nk-table>
                </el-col>
                <el-col :span="8" class="barTopright">
                  <guanf :pie1="pie1"></guanf>
                </el-col>
              </div>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import Bar from "./pages/bar";
import TimeSearch from "@/components/common/TimeSearch.vue";
import NkTable from "@/components/common/NkTable.vue";
import TabTree from "@/components/common/TabTree.vue";
import Bardd from "./pages/bardd";
import Guan from "./pages/guan";
import Guanf from "./pages/guanf";
import * as utils from "@/utils/index.js";
import * as handleData from "@/utils/handleData.js";
import * as fpg from "@/utils/fpg.js";
import tree from "@/utils/tree.js";
import { isNull, isUndefined } from "util";
import dateTool from "@/utils/dateTool";
import { findDataByParam } from "@/utils/index.js";
let allTimeData = [
  {
    type: "month",
    label: "月",
  },
  {
    type: "year",
    label: "年",
  },
];
export default {
  components: { TimeSearch, TabTree, Bar, Guan, Guanf, NkTable },
  data() {
    return {
      columns: [
        { prop: "total", width: 200, label: "序号" },
        { prop: "fValue", label: "峰期电(元)" },
        { prop: "pValue", label: "平期电(元)" },
        { prop: "gValue", label: "谷期电(元)" },
        { prop: "sum", label: "电度电费(元)" },
      ],
      tableData1: [],
      tableData2: [],
      treeTabObj: null,
      leftTreeData: [],
      // checkedKeys: [],
      treeData: {},
      alarnclass: "alarnclass", //时段需要选分秒
      dataType: "0",
      elem: { dataType: "0", dateType: "0", fromDate: "", toDate: "" },
      timeInterval: "toDay",
      barDate: {
        xdata: [],
        seriesData: [{ time: [] }, { time: [] }, { time: [] }, { time: [] }],
      }, //柱状图数据
      barDate1: {
        xdata: [],
        seriesData: [[], [], [], []],
        time: [],
        measureName: "",
        barDatedd: {},
        type: "df",
      },
      barDatedd: {
        xdata: [],
        seriesData: [[], [], [], []],
        dateType: "",
      },
      barDatedd1: {
        xdata: [],
        seriesData: [[], [], [], []],
        dateType: "",
      },
      pie: {}, //饼图数据用量
      pie1: {}, //饼图数据费用
      pie2: {}, //饼图数据用量
      pie3: {}, //饼图数据费用
      pointCode: "100229",
      pointNumber: "0",
      measureId: "", //计量点
      apiArr: [],
      fromDate: "",
      toDate: "",
      viewTreeData: null,
      timeData: allTimeData,
      selectedDate: null,
    };
  },
  created() {
    let vm = this;
    vm.$api.customUrl
      .getMyFrontEndPageCustomParam(
        vm.$store.state.user.currentCompanyId,
        "/nygl/fpgDf",
        null
      )
      .then((res) => {
        if (!res) {
          return;
        }
        vm.viewTreeData = findDataByParam("viewTree", true, res.data);
      });
  },
  mounted() {},
  activated() {},
  watch: {},
  methods: {
    /**
     * 点击查询事件
     */
    getSearchElem(elem) {
      let vm = this;
      // //生成这个月的天
      let xData = [];
      let startDate = new Date(elem.startTime);
      let thisDate = new Date(
        startDate.getFullYear(),
        startDate.getMonth() + 1,
        0
      ); //当天数为0 js自动处理为上一月的最后一天
      let days = thisDate.getDate();
      for (let index = 0; index < days; index++) {
        let thisDate = new Date(startDate);
        thisDate.setDate(index + 1);
        xData.push({
          title: index + 1,
        });
      }
      vm.tableData2 = [];
      if (elem.dateType == "month") {
        for (let i = 0; i < xData.length; i++) {
          vm.tableData2.push({
            total: xData[i].title,
            sum: null,
            fValue: null,
            pValue: null,
            gValue: null,
          });
          vm.tableData2[i].total = xData[i].title;
        }
      } else {
        for (let i = 0; i < 12; i++) {
          vm.tableData2.push({
            total: i,
            sum: null,
            fValue: null,
            pValue: null,
            gValue: null,
          });
        }
      }

      vm.tableData2[vm.tableData2.length] = {
        total: "合计",
        sum: null,
        fValue: null,
        pValue: null,
        gValue: null,
      };
      //   vm.elem.fromDate.s;
      elem.dataType = vm.dataType;
      vm.barDatedd.dateType = elem.dateType;
      vm.barDate1.dateType = elem.dateType;
      vm.selectedDate = elem;
      let getNextTime = fpg.getNextTime(elem.dateType); //拿取上一时间段的值
      let str = new Date(elem.startTime);
      str.setDate(str.getDate() + 1);
      let endTime = dateTool.format(new Date(str), "yyyy-MM-dd") + " 00:00:00";
      let timeData = JSON.parse(
        JSON.stringify(
          fpg.getMatchTime(elem.startTime, elem.endTime, elem.dateType)
        )
      ); //匹配查询时间
      let currentTime = [];
      if (elem.dateType == "5") {
        currentTime = JSON.parse(
          JSON.stringify(
            fpg.getCurrentMatchTime(elem.startTime, elem.endTime, elem.dateType)
          )
        ); //匹配当前时间
      } else {
        currentTime = JSON.parse(
          JSON.stringify(
            fpg.getMatchTime(elem.startTime, endTime, elem.dateType)
          )
        ); //查月時拿每月第一天,查年時每年第一天
      }
      vm.barDate.seriesData[0].time = timeData;
      vm.barDate.seriesData[1].time = timeData;
      vm.barDate.seriesData[2].time = timeData;
      vm.barDate.seriesData[3].time = timeData;
      vm.barDatedd1.seriesData[0].time = currentTime;
      vm.barDatedd1.seriesData[1].time = currentTime;
      vm.barDatedd1.seriesData[2].time = currentTime;
      vm.barDatedd1.seriesData[3].time = currentTime;
      vm.barDate1.time = timeData;
      let xdata1 = handleData.default.createXData(
        elem.dateType,
        elem.startTime,
        elem.endTime
      ); //获取柱状图x轴
      let dt = "";
      if (vm.elem.dateType == "2") {
        dt = "0";
      } else {
        dt = "2";
      }
      let xdata2 = handleData.default.createXData(
        dt,
        elem.startTime,
        elem.endTime
      ); //获取柱状图x轴
      //   let xdata2 = handleData.default.createXData(dt, vm.fromDate, vm.toDate); //获取柱状图x轴
      vm.barDate1.xdata = [];
      vm.barDatedd.xdata = [];
      for (let i = 0; i < xdata1.length; i++) {
        vm.barDate1.xdata.push(xdata1[i].title);
      }
      for (let i = 0; i < xdata2.length; i++) {
        vm.barDatedd.xdata.push(xdata2[i].title);
      }
      vm.apiArr = [];

      const dateObj = {
        day: "Hour",
        week: "Day",
        month: "Day",
        year: "Month",
      };
      vm.apiArr.push(
        vm.$api.cost[`getSpentMoney${dateObj[vm.selectedDate.dateType]}`](
          vm.measureId,
          elem.startTime,
          elem.endTime,
          vm.pointCode,
          vm.pointNumber,
          1,
          ""
        ) //谷
      );
      if (vm.selectedDate.dateType == "day") {
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyHour(
            vm.measureId,
            elem.startTime,
            elem.endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
      } else if (vm.selectedDate.dateType == "month") {
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyDay(
            vm.measureId,
            elem.startTime,
            elem.endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyHour(
            vm.measureId,
            elem.startTime,
            endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
      } else {
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyMonth(
            vm.measureId,
            elem.startTime,
            elem.endTime,
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
        vm.apiArr.push(
          vm.$api.cost.getSpentMoneyDay(
            vm.measureId,
            getNextTime[0],
            getNextTime[1],
            vm.pointCode,
            vm.pointNumber,
            1,
            ""
          ) //峰，平，谷。总费
        );
      }

      vm.getEDate();
    },
    //获取数据
    getEDate() {
      let vm = this;
      Promise.all(vm.apiArr).then((res) => {
        let barDate1 = JSON.parse(JSON.stringify(vm.barDate1));
        res[0].data = {detail: res[0].data.map(k => k.detail[0])}
        fpg.getEcharts(res[0].data, "pie"); //拿取当前饼图用电量,电费
        vm.pie2 = {
          yester: [
            {
              value: res[0].data.fValue == "-" ? 0 : res[0].data.fValue,
              name: "峰期用电量",
            },
            {
              value: res[0].data.pValue == "-" ? 0 : res[0].data.pValue,
              name: "平期用电量",
            },
            {
              value: res[0].data.gValue == "-" ? 0 : res[0].data.gValue,
              name: "谷期用电量",
            },
          ],
          dateType: vm.selectedDate.dateType,
        };
        vm.pie3 = {
          yester: [
            {
              value: res[0].data.fValue1 == "-" ? 0 : res[0].data.fValue1,
              name: "峰期用电费",
            },
            {
              value: res[0].data.pValue1 == "-" ? 0 : res[0].data.pValue1,
              name: "平期用电费",
            },
            {
              value: res[0].data.gValue1 == "-" ? 0 : res[0].data.gValue1,
              name: "谷期用电费",
            },
          ],
          dateType: vm.selectedDate.dateType,
        };
        let searchRes = []; //查询时间接口数据
        let searchCurrentRes = []; //当前时间接口
        if (vm.selectedDate.dateType == "month") {
          searchRes = res[1].data[0];
        } else {
          searchRes = res[1].data;
        }
        fpg.getEcharts(searchRes, "bar"); //拿取当前柱状图用电量,电费
        vm.barDate.seriesData[0].time = fpg.timeChabge1(
          vm.barDate.seriesData[0].time,
          searchRes,
          "f"
        ); //转换峰数据  拿当前月的
        vm.barDate.seriesData[1].time = fpg.timeChabge1(
          vm.barDate.seriesData[1].time,
          searchRes,
          "p"
        ); //转换平数据
        vm.barDate.seriesData[2].time = fpg.timeChabge1(
          vm.barDate.seriesData[2].time,
          searchRes,
          "g"
        ); //转换谷数据
        vm.barDate.seriesData[3].time = fpg.timeChabge1(
          vm.barDate.seriesData[3].time,
          searchRes,
          "total"
        ); //转换谷数据
        let sum = null;
        for (let i = 0; i < searchRes.length; i++) {
          //拿取表格数据
          let item = searchRes[i];
          vm.tableData2[i].fValue = item.fValue1;
          vm.tableData2[i].pValue = item.pValue1;
          vm.tableData2[i].gValue = item.gValue1;
          if (item.value) {
            vm.tableData2[i].sum = item.value.toFixed(2);
          }
        }

        let fing = null;
        let ping = null;
        let gu = null;
        let eleFree = null;
        for (let i = 0; i < vm.tableData2.length; i++) {
          let item = vm.tableData2[i];
          if (!isNull(item.fValue)) {
            item.fValue = parseFloat(item.fValue);
          }
          if (!isNull(item.pValue)) {
            item.pValue = parseFloat(item.pValue);
          }
          if (!isNull(item.gValue)) {
            item.gValue = parseFloat(item.gValue);
          }
          if (!isNull(item.fValue)) {
            item.sum = parseFloat(item.fValue);
          }
          if (!isNull(item.sum)) {
            item.sum = parseFloat(item.sum);
          }
          if (!isNaN(vm.tableData2[0].fValue) && !fing && fing != 0) {
            fing = parseFloat(vm.tableData2[0].fValue);
          } else {
            if (!isNull(item.fValue)) {
              fing += item.fValue;
            }
          }
          if (!isNaN(vm.tableData2[0].pValue) && !ping && ping != 0) {
            ping = parseFloat(vm.tableData2[0].pValue);
          } else {
            if (!isNull(item.pValue)) {
              ping += item.pValue;
            }
          }
          if (!isNaN(vm.tableData2[0].gValue) && !gu && gu != 0) {
            gu = parseFloat(vm.tableData2[0].gValue);
          } else {
            if (!isNull(item.gValue)) {
              gu += item.gValue;
            }
          }
          if (!isNaN(vm.tableData2[0].sum) && !eleFree && eleFree != 0) {
            eleFree = parseFloat(vm.tableData2[0].sum);
          } else {
            if (!isNull(item.sum)) {
              eleFree += item.sum;
            }
          }
        }
        vm.tableData2[vm.tableData2.length - 1].fValue = fing.toFixed(2);
        vm.tableData2[vm.tableData2.length - 1].pValue = ping.toFixed(2);
        vm.tableData2[vm.tableData2.length - 1].gValue = gu.toFixed(2);
        vm.tableData2[vm.tableData2.length - 1].sum = eleFree.toFixed(2);
        barDate1.seriesData = [[], [], [], []];
        vm.barDatedd.seriesData = [[], [], [], []];
        for (let i = 0; i < vm.barDate.seriesData.length; i++) {
          for (let j = 0; j < vm.barDate.seriesData[i].time.length - 1; j++) {
            barDate1.seriesData[i].push(vm.barDate.seriesData[i].time[j].value);
          }
        }
        for (let i = 0; i < vm.barDatedd1.seriesData.length; i++) {
          for (
            let j = 0;
            j < vm.barDatedd1.seriesData[i].time.length - 1;
            j++
          ) {
            vm.barDatedd.seriesData[i].push(
              vm.barDatedd1.seriesData[i].time[j].value
            );
          }
        }
        barDate1.barDatedd = vm.barDatedd;
        barDate1.barDatedd1 = vm.barDatedd1;
        let arr = JSON.parse(JSON.stringify(vm.tableData2));
        vm.barDate1 = JSON.parse(JSON.stringify(barDate1));
        vm.tableData1 = arr;
        vm.pie = vm.pie2;
        vm.pie1 = vm.pie3;
      });
    },
    //树加载
    tabTreeDefault(node) {
      let vm = this;
      vm.measureId = node.measureId;
      vm.barDate1.measureId = node.measureId;
      let time = new Date();
      let startTime = dateTool.format(time, "yyyy-MM-") + "01 00:00:00";
      time.setMonth(time.getMonth() + 1);
      let endTime = dateTool.format(new Date(time), "yyyy-MM-") + "01 00:00:00";
      vm.selectedDate = {
        dataType: "1",
        dateType: "month",
        endTime: endTime,
        startTime: startTime,
      };
      vm.getSearchElem(vm.selectedDate);
    },
    tabTreeClick(e) {
      this.measureId = e.measureId;
      this.barDate1.measureId = e.measureId;
      this.getSearchElem(this.selectedDate);
    },
  },
};
</script>
<style lang="scss">
.boxYl {
  .el-table th,
  .el-table tr {
    background-color: #fff;
    height: 50px;
  }
}
</style>
<style lang="scss" scoped>
.box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  padding: 20px;
  box-sizing: border-box;
}
.el-row {
  width: 100%;
  height: 100%;
  margin: 0 !important;
}
.el-col {
  border-radius: 4px;
  height: 100%;
}
.grid-content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #99a9bf;
}
.parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.tree_parentflex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  flex-direction: column;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
}
.treecontent {
  width: 100%;
  height: 100%;
  overflow: hidden;
  background: #f5f5f5;
  box-sizing: border-box;
}

.bgbox {
  position: relative;
  padding-top: 0;
  box-sizing: border-box;
  padding: 0;
}
.time_box {
  width: 100%;
}
.contant_box {
  position: absolute;
  background: #fff;
  top: 64px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  padding: 14px;
  padding-bottom: 0px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border: 1px solid #eee;
  border-radius: 5px;
}
.box_btn {
  height: 40px;
  width: 100%;
  line-height: 40px;
  display: flex;
  align-items: flex-end;
  border-bottom: 2px solid #00368e;
}
.box_btn p {
  font-size: 14px;
  color: #000;
  height: 30px;
  width: 96px;
  line-height: 30px;
  text-align: center;
  border: 1px solid #f5f5f5;
  border-bottom: none;
  cursor: pointer;
}
.box_btn .active {
  background: #00368e;
  color: #fff;
}
.box_con {
  position: absolute;
  top: 50px;
  bottom: 0px;
  width: 100%;
  display: flex;
}
.box_con_ {
  position: absolute;
  top: 45px;
  bottom: 0px;
  left: 0px;
  right: 0px;
  overflow: hidden;
}
.chart_box {
  position: absolute;
  top: 10px;
  width: 100%;
  height: 600px;
  overflow: hidden;
}
.table_box {
  position: absolute;
  top: 615px;
  width: 100%;
  height: auto;
}
.charts {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.elechart_box {
  width: 100%;
  height: auto;
}
.eletable_box {
  width: 100%;
  height: auto;
}
.barTop {
  height: 49%;
}
.barTopleft {
  padding-left: 0;
  padding-right: 10px;
}
.barTopright {
  padding-left: 10px;
  padding-right: 0;
}
.barbottom {
  height: 49%;
  margin-top: 20px;
}
</style>
